/**
 * How the component host element should change its size.
 * (Changes to this enum have n/n-1 implications)
 */
export enum LayoutMode {
  /** Use dimensions of host element */
  fixedByHost = 'fixedByHost',

  /** Use dimensions of render of component */
  grow = 'grow',

  /**
   * Use width of host element and height of render of component
   */
  growHeight = 'growHeight'
}

/**
 * Figures out how sizing of render should work between the host and the component
 * @see IFluidHTMLView in @fluidframework/core-interfaces
 * TODO: Look into moving this into fluid repo
 */
export function determineLayoutMode(element: HTMLElement): LayoutMode {
  // As per IComponentHTMLRender, if the div has a size already, the render is expected to fill the space
  // it has been given. If not, the render should grow based on its own content.

  const rect = element.getBoundingClientRect();

  if (rect.height === 0) {
    if (rect.width === 0) {
      return LayoutMode.grow;
    }

    return LayoutMode.growHeight;
  }

  return LayoutMode.fixedByHost;
}
